(() => {
  const root = document.querySelector('[data-cv6-g6-compact-buybox-root]');
  if (!root) return;

  const cfg = (() => {
    try {
      return JSON.parse(root.querySelector('[data-cv6-g6-compact-config]')?.textContent || '{}');
    } catch (error) {
      return {};
    }
  })();

  const variants = Array.isArray(cfg.variants) ? cfg.variants.filter((item) => item && item.id && item.available !== false) : [];
  if (!variants.length) return;

  const plans = Array.isArray(cfg.plans) ? cfg.plans : [];
  const i18n = cfg.i18n || {};
  const gift = cfg.gift || { variantId: 54674223071559, price: 1495, title: 'Mat Wit' };
  const giftCents = 1495;
  const giftVariantId = Number(gift?.variantId) || 54674223071559;
  const bundleArt = cfg.bundleArt || {};
  const washesPerPack = Math.max(1, Number(cfg.washesPerPack) || 100);
  const startPct = Number(cfg.subStartPct);
  const maxPct = Number(cfg.subMaxPct);
  const subStart = Number.isFinite(startPct) ? startPct / 100 : 0.10;
  const subMax = Number.isFinite(maxPct) ? maxPct / 100 : 0.15;
  const showGrowth = subMax > subStart + 0.0001;
  const planGroups = cfg.planGroups || { one: 78791508295, bundle: 78791475527 };
  const groupOne = Number(planGroups.one) || 78791508295;
  const groupBundle = Number(planGroups.bundle) || 78791475527;
  const freqLabel = (months) => {
    const n = Number(months) || 1;
    if (n === 1) return i18n.freqMonth || 'Elke maand';
    return (i18n.freqMonths || 'Elke {n} maanden').replace('{n}', String(n));
  };
  const bundleDefs = [
    { key: 'one', title: i18n.packOne || '1 verpakking', units: 1, payUnits: 1, flag: '', flagBg: '', flagInk: '', freqMonths: 1 },
    { key: 'plus1', title: i18n.packThree || '2 + 1 gratis', units: 3, payUnits: 2, flag: i18n.popular || 'Populair', flagBg: '#241f30', flagInk: '#fff', freqMonths: 4 },
    { key: 'plus3', title: i18n.packSix || '4 + 4 gratis', units: 8, payUnits: 4, flag: i18n.bestDeal || 'Beste deal', flagBg: '#7a4fa8', flagInk: '#fff', freqMonths: 12 }
  ];

  const bestseller = variants.find((item) => /lente|spring/i.test(item.title || '')) || variants[0];
  const state = {
    scents: [String(bestseller.id)],
    bundle: 1,
    plan: 'once',
    freqMonths: 4,
    mixOpen: false,
    mixQty: null
  };

  const els = {
    headPrice: root.querySelector('[data-g6bb-head-price]'),
    headCompare: root.querySelector('[data-g6bb-head-compare]'),
    headSave: root.querySelector('[data-g6bb-head-save]'),
    headUnit: root.querySelector('[data-g6bb-head-unit]'),
    scentNote: root.querySelector('[data-g6bb-scent-note]'),
    scentGrid: root.querySelector('[data-g6bb-scents]'),
    mixChips: root.querySelectorAll('[data-g6bb-mix-chips]'),
    mixNote: root.querySelectorAll('[data-g6bb-mix-note]'),
    bundleNote: root.querySelector('[data-g6bb-bundle-note]'),
    bundleGrid: root.querySelector('[data-g6bb-bundles]'),
    once: root.querySelector('[data-g6bb-once]'),
    sub: root.querySelector('[data-g6bb-sub]'),
    oncePrice: root.querySelector('[data-g6bb-once-price]'),
    subPrice: root.querySelector('[data-g6bb-sub-price]'),
    freqWrap: root.querySelector('[data-g6bb-freq-wrap]'),
    freq: root.querySelector('[data-g6bb-freq]'),
    freqLock: root.querySelector('[data-g6bb-freq-lock]'),
    startPrice: root.querySelector('[data-g6bb-start-price]'),
    maxPrice: root.querySelector('[data-g6bb-max-price]'),
    maxTotal: root.querySelector('[data-g6bb-max-total]'),
    maxTotalPct: root.querySelector('[data-g6bb-max-total-pct]'),
    growth: root.querySelector('[data-g6bb-growth]'),
    mixPanel: root.querySelector('[data-g6bb-mix-panel]'),
    mixEdit: root.querySelector('[data-g6bb-mix-edit]'),
    mixEditNote: root.querySelector('[data-g6bb-mix-edit-note]'),
    mixToggle: root.querySelector('[data-g6bb-mix-toggle]'),
    mixChevron: root.querySelector('[data-g6bb-mix-chevron]'),
    submit: root.querySelector('[data-cv6-g6-compact-submit]'),
    status: root.querySelector('[data-g6bb-status]'),
    miss: root.querySelector('[data-g6bb-miss]'),
    missKorting: root.querySelector('[data-g6bb-miss-korting]'),
    missGifts: root.querySelectorAll('[data-g6bb-miss-gifts]'),
    missTin: root.querySelector('[data-g6bb-miss-tin]'),
    cycleGifts: root.querySelector('[data-g6bb-cycle-gifts]'),
    wimDeal: root.querySelector('[data-g6bb-wim-deal]')
  };

  const money = (cents) => {
    const value = Math.round(Number(cents) || 0) / 100;
    return '€' + value.toFixed(2).replace('.', ',');
  };
  const variantById = (id) => variants.find((item) => String(item.id) === String(id));
  const shortName = (title) => String(title || '').replace(/\s*G6\s*100\s*/i, '').trim();
  const currentBundle = () => bundleDefs[state.bundle] || bundleDefs[1];
  const allowedGroupId = (bundle) => ((bundle || currentBundle()).key === 'one' ? groupOne : groupBundle);
  const planInGroup = (plan, groupId) => {
    const raw = String(plan.groupId || '');
    const numeric = Number(String(raw).replace(/\D/g, ''));
    if (numeric === Number(groupId)) return true;
    const name = String(plan.groupName || '').toLowerCase();
    if (Number(groupId) === groupOne) return name.includes('1 maand');
    if (Number(groupId) === groupBundle) return name.includes('4/12') || name.includes('4 / 12');
    return false;
  };
  const allowedPlans = (bundle) => plans.filter((plan) => planInGroup(plan, allowedGroupId(bundle)));
  const lockedMonths = (bundle) => {
    const target = Number((bundle || currentBundle()).freqMonths) || 1;
    const available = allowedPlans(bundle).map((plan) => Number(plan.months));
    if (available.includes(target)) return target;
    if (available.includes(Number(state.freqMonths))) return Number(state.freqMonths);
    return available[0] || target;
  };
  const baseCents = () => Number(variantById(state.scents[0])?.price) || Number(variants[0].price) || 0;
  const selectedPlan = () => {
    const wanted = Number(state.freqMonths) || lockedMonths();
    const pool = allowedPlans();
    return pool.find((plan) => Number(plan.months) === wanted) || pool[0] || null;
  };

  function emit(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...detail });
    } catch (_) {}
  }

  function autoMix(ids, units) {
    const map = {};
    if (!ids.length) return map;
    const each = Math.floor(units / ids.length);
    const rem = units % ids.length;
    ids.forEach((id, index) => {
      map[id] = each + (index < rem ? 1 : 0);
    });
    return map;
  }

  function mixMap() {
    const bundle = currentBundle();
    if (!state.mixQty) state.mixQty = autoMix(state.scents, bundle.units);
    return state.mixQty;
  }

  function planPct(plan) {
    const raw = Number(plan?.pct);
    if (!Number.isFinite(raw) || raw <= 0) return 0;
    return raw > 1 ? raw / 100 : raw;
  }
  function subscriptionBundleTotal(unit, bundle, subPct) {
    const bundleDiscountPct = bundle.key === 'plus1' ? 0.3334 : (bundle.key === 'plus3' ? 0.50 : 0);
    const subUnit = Math.round(unit * (1 - subPct));
    const subNetUnit = subUnit - Math.floor(subUnit * bundleDiscountPct);
    return subNetUnit * bundle.units;
  }
  function hasCycleGifts() {
    const months = lockedMonths();
    return months === 4 || months === 12;
  }
  function subChipMarkup() {
    const raw = String(i18n.subChip || '+abonnements korting');
    if (/abonnementskorting/i.test(raw)) {
      return '<span class="g6bb__subchip"><span>+abonnements</span><span>korting</span></span>';
    }
    const trimmed = raw.replace(/^\+\s*/, '+').trim();
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      const bottom = parts.pop();
      return `<span class="g6bb__subchip"><span>${parts.join(' ')}</span><span>${bottom}</span></span>`;
    }
    return `<span class="g6bb__subchip">${raw}</span>`;
  }
  function pricing() {
    const bundle = currentBundle();
    const unit = baseCents();
    const tin = bundle.key === 'plus3' ? giftCents : 0;
    const normal = unit * bundle.units;
    const payOnce = unit * bundle.payUnits;
    const isSub = state.plan === 'sub';
    const firstPct = isSub ? planPct(selectedPlan()) : 0;
    const subPct = planPct(selectedPlan()) || subStart;
    const payStartStory = subscriptionBundleTotal(unit, bundle, subStart);
    const payFirst = isSub ? subscriptionBundleTotal(unit, bundle, firstPct) : payOnce;
    const subPayFirst = subscriptionBundleTotal(unit, bundle, subPct);
    const payMax = isSub ? subscriptionBundleTotal(unit, bundle, subMax) : payOnce;
    const payable = isSub ? payFirst : payOnce;
    const saveShown = Math.max(0, normal - payable + tin);
    return { bundle, unit, normal, payOnce, payStartStory, payFirst, subPayFirst, payMax, payable, isSub, tin, saveShown, firstPct, subPct };
  }

  function setPressed(node, on, selectedBorder, idleBorder, selectedBg, idleBg) {
    if (!node) return;
    node.setAttribute('aria-pressed', on ? 'true' : 'false');
    node.style.border = on ? selectedBorder : idleBorder;
    node.style.background = on ? selectedBg : idleBg;
  }

  function renderScents() {
    if (!els.scentGrid) return;
    const max = currentBundle().units;
    els.scentGrid.innerHTML = variants.map((variant) => {
      const selected = state.scents.includes(String(variant.id));
      const icon = variant.icon || '';
      return `<button type="button" class="g6bb__scent" data-g6bb-scent="${variant.id}" aria-pressed="${selected ? 'true' : 'false'}" style="border:${selected ? '2px solid #7ed07a' : '2px solid rgba(255,255,255,.8)'};background:${selected ? 'rgba(220,244,218,.85)' : 'rgba(255,255,255,.6)'}">
        ${icon ? `<span class="g6bb__scent-icon" aria-hidden="true">${icon}</span>` : ''}
        <span class="g6bb__scent-name">${shortName(variant.title)}</span>
        <span class="g6bb__scent-check" ${selected ? '' : 'hidden'}>✓</span>
      </button>`;
    }).join('');
    if (els.scentNote) {
      els.scentNote.textContent = max === 1
        ? (i18n.scentSingle || 'Selecteer de optie die bij je past')
        : (i18n.scentMix || 'Mix je geuren, kies er tot {max} ({n} gekozen)')
          .replace('{max}', String(max))
          .replace('{n}', String(state.scents.length));
    }
  }

  function renderBundles() {
    if (!els.bundleGrid) return;
    const price = pricing();
    els.bundleGrid.innerHTML = bundleDefs.map((bundle, index) => {
      const selected = state.bundle === index;
      const firstPct = price.isSub ? (price.firstPct || subStart) : 0;
      const effPay = price.isSub ? subscriptionBundleTotal(price.unit, bundle, firstPct) : bundle.payUnits * price.unit;
      const normal = bundle.units * price.unit;
      const tin = bundle.key === 'plus3' ? giftCents : 0;
      const saved = Math.max(0, normal - effPay + tin);
      const denom = normal + tin;
      const washes = bundle.units * washesPerPack;
      return `<button type="button" class="g6bb__bundle" data-g6bb-bundle="${index}" aria-pressed="${selected ? 'true' : 'false'}" style="border:${selected ? '2px solid #7ed07a' : '2px solid rgba(255,255,255,.8)'};background:${selected ? 'rgba(220,244,218,.7)' : 'rgba(255,255,255,.6)'}">
        ${bundle.flag ? `<span class="g6bb__flag" style="background:${bundle.flagBg};color:${bundle.flagInk}">${bundle.flag}</span>` : ''}
        ${bundleArt[bundle.key] ? `<img class="g6bb__pack-art" src="${bundleArt[bundle.key]}" alt="" width="188" height="112">` : '<span class="g6bb__pack-art" aria-hidden="true"></span>'}
        <strong>${bundle.title}</strong>
        <small>${washes} ${i18n.washes || 'wasbeurten'}</small>
        <span class="g6bb__bundle-price">${money(effPay)}${price.isSub ? (' ' + (i18n.perDeliveryShort || '/lev.')) : ''}${saved ? `<s>${money(normal)}</s>` : ''}</span>
        <span class="g6bb__pills">
          <em style="background:${saved ? '#dcf4da' : 'rgba(80,60,110,.07)'};color:${saved ? '#3f8c3b' : '#847c96'}">${saved ? '−' + money(saved) + ' ' + (i18n.discount || 'korting') : (i18n.standard || 'standaardprijs')}</em>
          ${saved ? `<em class="g6bb__pct">−${Math.round(saved / Math.max(1, denom) * 100)}%</em>` : ''}
          ${tin ? `<span class="g6bb__giftline">🎁 ${(i18n.giftTin || 'Gratis bewaarblik t.w.v. {price}').replace('{price}', money(tin))}</span>` : ''}
        </span>
        ${price.isSub ? subChipMarkup() : ''}
        <span class="g6bb__perwash">${money(effPay / washes)} / ${i18n.wash || 'wasbeurt'}</span>
      </button>`;
    }).join('');
    if (els.bundleNote) {
      els.bundleNote.textContent = price.isSub
        ? (i18n.bundleOnSub || 'Abonnementskorting komt bovenop de bundelkorting')
        : (i18n.bundleOnce || 'Korting direct verrekend');
    }
  }

  function renderMix() {
    const bundle = currentBundle();
    const map = mixMap();
    const chips = state.scents.map((id) => {
      const qty = map[id] || 0;
      if (!qty) return '';
      return `<span class="g6bb__chip">${qty}× ${shortName(variantById(id)?.title)}</span>`;
    }).join('') + (bundle.key === 'plus3' ? `<span class="g6bb__chip">${i18n.giftTinChip || '1× bewaarblik cadeau'}</span>` : '');
    const note = `= ${bundle.units} ${bundle.units === 1 ? (i18n.pack || 'verpakking') : (i18n.packs || 'verpakkingen')} · ${bundle.units * washesPerPack} ${i18n.washes || 'wasbeurten'}`;
    els.mixChips.forEach((node) => { node.innerHTML = chips; });
    els.mixNote.forEach((node) => { node.textContent = note; });
    if (els.mixPanel) els.mixPanel.hidden = !state.mixOpen;
    if (els.mixChevron) els.mixChevron.textContent = state.mixOpen ? (i18n.close || 'sluiten ▴') : (i18n.adjust || 'aanpassen ▾');
    if (els.mixEdit) {
      els.mixEdit.innerHTML = state.scents.map((id) => {
        const qty = map[id] || 0;
        const disabled = state.scents.length < 2 ? 'disabled' : '';
        return `<div class="g6bb__mix-row">
          <span>${shortName(variantById(id)?.title)}</span>
          <button type="button" data-g6bb-minus="${id}" ${disabled}>−</button>
          <b>${qty}</b>
          <button type="button" data-g6bb-plus="${id}" ${disabled}>+</button>
        </div>`;
      }).join('');
    }
    if (els.mixEditNote) {
      els.mixEditNote.textContent = state.scents.length < 2
        ? (i18n.mixNeedMore || 'Kies meerdere geuren bij stap 1 om de verdeling aan te passen.')
        : (i18n.mixKeepTotal || 'Totaal blijft {n} verpakkingen, een plus bij de ene geur haalt er een weg bij de andere.').replace('{n}', String(bundle.units));
    }
  }

  function renderPlan() {
    const price = pricing();
    setPressed(els.once, !price.isSub, '2px solid #7ed07a', '2px solid rgba(255,255,255,.8)', 'rgba(220,244,218,.7)', 'rgba(255,255,255,.6)');
    setPressed(els.sub, price.isSub, '2px solid #b79ce0', '2px solid rgba(255,255,255,.8)', 'rgba(233,222,247,.7)', 'rgba(255,255,255,.6)');
    if (els.oncePrice) els.oncePrice.textContent = money(price.payOnce);
    if (els.subPrice) els.subPrice.textContent = money(price.subPayFirst);
    if (els.freqWrap) els.freqWrap.hidden = !price.isSub;
    const months = lockedMonths();
    if (!allowedPlans().some((plan) => Number(plan.months) === Number(state.freqMonths))) {
      state.freqMonths = months;
    }
    const pool = allowedPlans().slice().sort((a, b) => Number(a.months) - Number(b.months));
    if (els.freq) {
      els.freq.hidden = pool.length < 2;
      els.freq.innerHTML = pool.map((plan) => {
        const value = Number(plan.months);
        const selected = value === Number(state.freqMonths) ? ' selected' : '';
        return `<option value="${value}"${selected}>${freqLabel(value)}</option>`;
      }).join('');
      els.freq.value = String(state.freqMonths);
    }
    if (els.freqLock) {
      els.freqLock.hidden = pool.length > 1;
      els.freqLock.textContent = pool.length > 1 ? '' : freqLabel(state.freqMonths);
    }
    if (els.startPrice) els.startPrice.textContent = money(price.payStartStory) + ' ' + (i18n.perDeliveryShort || '/lev.');
    if (els.maxPrice) els.maxPrice.textContent = money(price.payMax) + ' ' + (i18n.perDeliveryShort || '/lev.');
    if (els.maxTotal) els.maxTotal.textContent = (i18n.totalSave || 'totale korting −') + money(price.normal - price.payMax + price.tin);
    if (els.maxTotalPct) els.maxTotalPct.textContent = '−' + Math.round((price.normal - price.payMax + price.tin) / Math.max(1, price.normal + price.tin) * 100) + '%';
    if (els.growth) els.growth.hidden = false;
    if (els.miss) els.miss.hidden = price.isSub;
    if (els.missKorting) {
      els.missKorting.textContent = (i18n.missKorting || '{start} directe korting, oplopend naar {max} vanaf de 4e levering')
        .replace('{start}', money(Math.round(price.payOnce * subStart)))
        .replace('{max}', money(Math.round(price.payOnce * subMax)));
    }
    els.missGifts.forEach((node) => { node.hidden = price.bundle.key === 'one'; });
    if (els.missTin) els.missTin.hidden = price.bundle.key !== 'plus3';
    if (els.cycleGifts) els.cycleGifts.hidden = !(price.isSub && hasCycleGifts());
    if (els.wimDeal) {
      const year = bundleDefs[2];
      const yearPay = price.isSub ? subscriptionBundleTotal(price.unit, year, subStart) : year.payUnits * price.unit;
      const perWash = (yearPay / 100) / (year.units * washesPerPack);
      els.wimDeal.textContent = (i18n.wimDealFmt || '4+4 = {price} per beurt').replace('{price}', '€' + (perWash).toFixed(2).replace('.', ','));
    }
    const badge = root.querySelector('[data-g6bb-sub-badge]');
    if (badge) badge.textContent = (i18n.growsTo || 'Korting groeit tot {pct}%').replace('{pct}', String(Math.round(subMax * 100)));
  }

  function renderHeaderAndCta() {
    const price = pricing();
    if (els.headPrice) {
      const washes = Math.max(1, price.bundle.units * washesPerPack);
      const perWash = (price.payable / 100) / washes;
      els.headPrice.textContent = '€' + perWash.toFixed(2).replace('.', ',');
    }
    if (els.headSave) {
      if (price.saveShown > 0) {
        els.headSave.textContent = '−' + money(price.saveShown);
        els.headSave.hidden = false;
      } else {
        els.headSave.textContent = '';
        els.headSave.hidden = true;
      }
    }
    if (els.headUnit) {
      const washes = price.bundle.units * washesPerPack;
      els.headUnit.textContent = `${washes} ${i18n.washes || 'wasbeurten'} · ${i18n.inclVat || 'incl. btw'}`;
    }
    if (els.submit) {
      const label = price.isSub
        ? `${i18n.atc || 'In winkelmand'} · ${money(price.payable)} / ${i18n.delivery || 'levering'}`
        : `${i18n.atc || 'In winkelmand'} · ${money(price.payable)}`;
      els.submit.textContent = label;
    }
    try {
      const detail = {
        payable: price.payable,
        compare: price.normal,
        formatted: money(price.payable),
        compareFormatted: money(price.normal),
        isSub: price.isSub,
        bundleKey: price.bundle.key,
        units: price.bundle.units
      };
      window.__g6bbStickyPrice = detail;
      document.dispatchEvent(new CustomEvent('g6bb:price', { bubbles: true, detail }));
    } catch (_) {}
    const hiddenId = document.querySelector('[data-cv6-default-pdp] .product-variant-id, [data-cv6-g6-compact-buybox] .product-variant-id');
    if (hiddenId) hiddenId.value = state.scents[0];
    const qty = document.querySelector('[data-cv6-default-pdp] [data-qty]');
    if (qty) qty.value = String(price.bundle.units);
  }

  function render() {
    renderScents();
    renderBundles();
    renderMix();
    renderPlan();
    renderHeaderAndCta();
  }

  function selectScent(id) {
    const key = String(id);
    const max = currentBundle().units;
    let next = state.scents.slice();
    if (next.includes(key)) {
      if (next.length > 1) next = next.filter((item) => item !== key);
    } else if (max === 1) {
      next = [key];
    } else {
      if (next.length >= max) next.shift(); // oldest
      next.push(key);
    }
    state.scents = next;
    state.mixQty = null;
    emit('g6_buybox_scent_mix', { scents: state.scents, bundle: currentBundle().key });
    render();
  }

  function selectBundle(index) {
    const next = bundleDefs[index];
    if (!next) return;
    state.bundle = index;
    state.freqMonths = next.freqMonths;
    if (state.scents.length > next.units) state.scents = state.scents.slice(-next.units);
    state.mixQty = null;
    emit('g6_buybox_bundle', { bundle: next.key, units: next.units });
    render();
  }

  function nudge(id, delta) {
    if (state.scents.length < 2) return;
    const map = Object.assign({}, mixMap());
    if (delta > 0) {
      const donor = state.scents
        .filter((item) => item !== id && (map[item] || 0) > 0)
        .sort((a, b) => (map[b] || 0) - (map[a] || 0))[0];
      if (!donor) return;
      map[donor] -= 1;
      map[id] = (map[id] || 0) + 1;
    } else {
      if ((map[id] || 0) <= 0) return;
      const recv = state.scents
        .filter((item) => item !== id)
        .sort((a, b) => (map[a] || 0) - (map[b] || 0))[0];
      if (!recv) return;
      map[id] -= 1;
      map[recv] = (map[recv] || 0) + 1;
    }
    state.mixQty = map;
    render();
  }

  async function addToCart() {
    const price = pricing();
    const map = mixMap();
    const bundleId = 'g6-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    const plan = price.isSub ? selectedPlan() : null;
    if (price.isSub && !plan) {
      if (els.status) els.status.textContent = i18n.planMissing || 'Abonnement is tijdelijk niet beschikbaar. Kies eenmalig of een andere frequentie.';
      return;
    }
    const items = state.scents.map((id) => {
      const quantity = Number(map[id] || 0);
      if (quantity <= 0) return null;
      const item = {
        id: Number(id),
        quantity,
        properties: {
          _bundle_id: bundleId,
          _bundle_key: price.bundle.key,
          _bundle_label: price.bundle.title
        }
      };
      if (plan) item.selling_plan = Number(plan.id);
      return item;
    }).filter(Boolean);
    const giftItem = (price.bundle.key === 'plus3' && giftVariantId) ? {
      id: giftVariantId,
      quantity: 1,
      properties: {
        _bundle_id: bundleId,
        _bundle_key: price.bundle.key,
        _g6_gift: 'jaarvoorraad-bewaarblik',
        _bundle_label: 'Gratis bij jaarvoorraad'
      }
    } : null;
    if (!items.length) return;
    const original = els.submit?.textContent || '';
    if (els.submit) {
      els.submit.disabled = true;
      els.submit.textContent = i18n.adding || 'Bezig...';
    }
    if (els.status) els.status.textContent = '';
    const postItems = (batch) => new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.withCredentials = true;
      xhr.onload = () => {
        let body = {};
        try { body = JSON.parse(xhr.responseText || '{}'); } catch (_) {}
        if (xhr.status >= 200 && xhr.status < 300) resolve(body);
        else reject(new Error(i18n.addFailed || 'Toevoegen mislukt, probeer het nogmaals'));
      };
      xhr.onerror = () => reject(new Error(i18n.addFailed || 'Toevoegen mislukt, probeer het nogmaals'));
      xhr.send(JSON.stringify({
        items: batch,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      }));
    });
    const syncCartUi = async (payload) => {
      const drawer = document.querySelector('cart-drawer[data-cosmeau-cart], cart-drawer');
      if (drawer && payload && payload.sections && typeof drawer.renderContents === 'function') {
        try { drawer.renderContents(payload); } catch (_) {}
      }
      drawer?.classList?.remove('is-empty');
      try { drawer?.open?.(); } catch (_) {}
      try {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'g6-buybox', cartData: payload });
        }
      } catch (_) {}
      ['cart:refresh', 'cart:updated', 'cart_changed', 'cart:change'].forEach((name) => {
        try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload })); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload })); } catch (_) {}
      });
      if (window.CosmeauCartDrawer?.sync && payload?.items) {
        try { await window.CosmeauCartDrawer.sync(payload); } catch (_) {}
      }
    };
    try {
      let payload = await postItems(items);
      if (giftItem) payload = await postItems([giftItem]);
      if (!payload.sections) {
        payload = await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', '/cart.js?sections=cart-drawer,cart-icon-bubble');
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.onload = () => {
            try { resolve(JSON.parse(xhr.responseText || '{}')); } catch (error) { reject(error); }
          };
          xhr.onerror = () => reject(new Error(i18n.addFailed || 'Toevoegen mislukt, probeer het nogmaals'));
          xhr.send();
        });
      }
      await syncCartUi(payload);
      if (els.submit) els.submit.textContent = i18n.added || 'Toegevoegd';
      if (els.status) els.status.textContent = i18n.addedToCart || 'Toegevoegd aan winkelmand';
      emit('g6_buybox_add', { bundle: price.bundle.key, plan: price.isSub ? 'sub' : 'once', items: items.length + (giftItem ? 1 : 0) });
    } catch (error) {
      if (els.status) els.status.textContent = error.message || i18n.addFailed || 'Toevoegen mislukt, probeer het nogmaals';
    } finally {
      window.setTimeout(() => {
        if (els.submit) {
          els.submit.disabled = false;
          renderHeaderAndCta();
          if (!els.submit.textContent) els.submit.textContent = original;
        }
      }, 1100);
    }
  }

  root.addEventListener('click', (event) => {
    const scent = event.target.closest('[data-g6bb-scent]');
    if (scent) { selectScent(scent.getAttribute('data-g6bb-scent')); return; }
    const bundle = event.target.closest('[data-g6bb-bundle]');
    if (bundle) { selectBundle(Number(bundle.getAttribute('data-g6bb-bundle'))); return; }
    if (event.target.closest('[data-g6bb-once]')) { state.plan = 'once'; emit('g6_buybox_plan', { plan: 'once' }); render(); return; }
    if (event.target.closest('[data-g6bb-sub]')) { state.plan = 'sub'; emit('g6_buybox_plan', { plan: 'sub' }); render(); return; }
    if (event.target.closest('[data-g6bb-mix-toggle]')) { state.mixOpen = !state.mixOpen; render(); return; }
    const plus = event.target.closest('[data-g6bb-plus]');
    if (plus) { nudge(plus.getAttribute('data-g6bb-plus'), 1); return; }
    const minus = event.target.closest('[data-g6bb-minus]');
    if (minus) { nudge(minus.getAttribute('data-g6bb-minus'), -1); return; }
    if (event.target.closest('[data-cv6-g6-compact-submit]')) { event.preventDefault(); addToCart(); }
  });

  els.freq?.addEventListener('change', () => {
    state.freqMonths = Number(els.freq.value) || 1;
    render();
  });

  const hostForm = document.querySelector('[data-cv6-g6-compact-buybox] [data-type="add-to-cart-form"], [data-cv6-default-pdp][data-cv6-g6-compact-buybox] form[data-type="add-to-cart-form"]');
  hostForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart();
  }, true);

  render();
})();
